import SimpleLayout from '../../../layouts/SimpleLayout';
import logo from '../../../assets/img/logo.png';
import { Link } from 'react-router-dom';
import illustration from '../../../assets/img/svg/server-error.svg';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../../utils/context/AuthContext';

const ServerErrorPage = () => {
    const { logout } = useAuth();

    //#region isError

    // TODO
    // const error = sessionStorage.getItem('error');
    // if (error !== 'server-error') {
    //     window.location.href = '/';
    //     return null;
    // }

    // sessionStorage.removeItem('error');

    //#endregion

    return (
        <>
            <Helmet>
                <title>500 - Erreur serveur :: Portail PETROSIL</title>
            </Helmet>

            <div className="page page-center">
                <div className="container-tight py-4">
                    <div className="text-center">
                        <a href="/" className="navbar-brand navbar-brand-autodark">
                            <img src={logo} alt="Logo" width="150" height="auto" />
                        </a>
                    </div>
                    <div className="empty">
                        <p className="empty-title">500 - Erreur serveur</p>
                        <p className="empty-subtitle text-secondary">Une erreur inattendue s'est produite. Veuillez réessayer plus tard.</p>

                        <div className="mt-2 mb-2">
                            <img src={illustration} alt="500 - Erreur serveur" />
                        </div>

                        <div className="empty-action">
                            <button
                                type="button"
                                className="btn btn-6 btn-x btn-icon mx-1"
                                onClick={() => {
                                    logout();
                                    window.location.href = '/';
                                }}
                                title="Déconnexion"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-logout-2">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2" />
                                    <path d="M15 12h-12l3 -3" />
                                    <path d="M6 15l-3 -3" />
                                </svg>
                            </button>

                            <Link to="/" className="btn btn-primary btn-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-home">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                                    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                                    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
                                </svg>
                                Accueil
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

ServerErrorPage.Layout = SimpleLayout;

export default ServerErrorPage;
